/**
 * ServiceAlert API Documentation
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PhoneNumberTypeEnum = {
    PhoneNormalLandLine: 'PHONE_NORMAL_LAND_LINE',
    PhoneNormalMobile: 'PHONE_NORMAL_MOBILE'
} as const;
export type PhoneNumberTypeEnum = typeof PhoneNumberTypeEnum[keyof typeof PhoneNumberTypeEnum];

